import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* LIBRARIES */
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import classNames from 'classnames';
import { pick } from 'ramda';
/* MODULES */

import { getSlaveStylesClasses, getInlineStyles } from './helpers';
import { Outside } from '../outside';
/* STYLES */

import * as stylesModule from './modalView.css';
/* TYPES */

import { CrossIcon } from '../icons/cross';
/* CONSTANTS */

export var HANDLERS_ARRAY = ['onClose'];
export * from './types';
export var ModalView = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ModalView, _React$PureComponent);

  var _super = _createSuper(ModalView);

  function ModalView() {
    var _this;

    _classCallCheck(this, ModalView);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isMounted: false
    });

    _defineProperty(_assertThisInitialized(_this), "handleClose", function () {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleBackgroundClick", function (e) {
      e.stopPropagation();
    });

    return _this;
  }

  _createClass(ModalView, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        isMounted: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames,
          _classNames2,
          _this2 = this;

      var _this$props = this.props,
          _this$props$__attribu = _this$props.__attributes,
          __attributes = _this$props$__attribu === void 0 ? {} : _this$props$__attribu,
          children = _this$props.children,
          _this$props$dataMark = _this$props.dataMark,
          dataMark = _this$props$dataMark === void 0 ? 'ModalView' : _this$props$dataMark,
          _this$props$__classNa = _this$props.__classNames,
          __classNames = _this$props$__classNa === void 0 ? '' : _this$props$__classNa,
          _this$props$styles = _this$props.styles,
          styles = _this$props$styles === void 0 ? {} : _this$props$styles,
          _this$props$custom = _this$props.custom,
          custom = _this$props$custom === void 0 ? {} : _this$props$custom;

      var isMounted = this.state.isMounted;
      var _custom$mediaType = custom.mediaType,
          mediaType = _custom$mediaType === void 0 ? 'all' : _custom$mediaType,
          _custom$mount = custom.mount,
          mount = _custom$mount === void 0 ? false : _custom$mount,
          _custom$open = custom.open,
          open = _custom$open === void 0 ? false : _custom$open;
      var handlers = pick(HANDLERS_ARRAY, this.props);

      if (!isMounted || !mount && !open) {
        return null;
      }

      return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement("div", _extends({
        "data-mark": dataMark,
        className: classNames(stylesModule['slave'], (_classNames = {}, _defineProperty(_classNames, getSlaveStylesClasses({
          styles: styles,
          custom: custom
        }), true), _defineProperty(_classNames, stylesModule['slave-opened'], open), _classNames), __classNames)
      }, __attributes, handlers), /*#__PURE__*/React.createElement("div", {
        "data-mark": "ModalViewBackground",
        onClick: this.handleBackgroundClick,
        className: stylesModule['background']
      }), /*#__PURE__*/React.createElement(Outside, {
        onOutside: this.handleClose
      }, /*#__PURE__*/React.createElement("div", {
        className: stylesModule['outside']
      }, /*#__PURE__*/React.createElement("div", {
        className: classNames(stylesModule['slaveContainer'], (_classNames2 = {}, _defineProperty(_classNames2, stylesModule["slaveContainer-backgroundColor--".concat(styles.backgroundColor)], styles.backgroundColor), _defineProperty(_classNames2, stylesModule["slaveContainer-borderColor--".concat(styles.borderColor)], styles.borderColor), _classNames2)),
        style: getInlineStyles({
          styles: styles,
          custom: custom
        })
      }, /*#__PURE__*/React.createElement("div", {
        "data-mark": "ModalViewCross",
        "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
        className: classNames(stylesModule['cross'], _defineProperty({}, stylesModule["cross-mediaType--".concat(mediaType)], true)),
        onClick: function onClick(event) {
          /* istanbul ignore next line */
          event.stopPropagation();

          _this2.handleClose();
        }
      }, /*#__PURE__*/React.createElement(CrossIcon, {
        styles: {
          color: custom.crossColor || '999999'
        },
        custom: {
          size: '12'
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: classNames(stylesModule['content'], _defineProperty({}, stylesModule["content-mediaType--".concat(mediaType)], true))
      }, children))))), document.body);
    }
  }]);

  return ModalView;
}(React.PureComponent);